import { render, staticRenderFns } from "./alarmComparison.vue?vue&type=template&id=1b6169d0&scoped=true"
import script from "./alarmComparison.vue?vue&type=script&lang=js"
export * from "./alarmComparison.vue?vue&type=script&lang=js"
import style0 from "./alarmComparison.vue?vue&type=style&index=0&id=1b6169d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6169d0",
  null
  
)

export default component.exports